<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="センサー設定">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row dense>
                        <v-col>
                            <v-checkbox 
                                v-model="editItems.disabled" 
                                label="このセンサーを無効にする"
                                hide-details />
                        </v-col>
                    </v-row>
                    <h2 class="mt-4 mb-2">基本設定</h2>
                    <v-row>
                        <v-col>
                            <v-card outlined>
                                <v-card-text class="pa-0">
                                    <v-container fluid class="pt-0">
                                        <v-row>
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                                                <v-text-field
                                                    v-model="editItems.sensorKey"
                                                    dense
                                                    clearable
                                                    hide-details
                                                    label="センサーコード"
                                                    item-text="text"
                                                    outlined
                                                    :disabled="targetSensor != null" />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-select
                                                    v-model="editItems.type"
                                                    :items="sensorTypes"
                                                    item-text="text"
                                                    item-value="type"
                                                    label="センサー種類"
                                                    hide-details
                                                    :disabled="targetSensor != null"  />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col v-if="editItems.type == 1">
                                                <v-text-field
                                                    v-model="editItems.type1WireData.id"
                                                    dense
                                                    clearable
                                                    hide-details
                                                    label="センサーID"
                                                    item-text="text"
                                                    outlined
                                                    :disabled="targetSensor != null" />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                            <v-text-field
                                v-model="editItems.name"
                                dense
                                clearable
                                hide-details
                                label="センサー名称"
                                item-text="text"
                                outlined />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                            <v-text-field
                                v-model="editItems.unit"
                                dense
                                clearable
                                hide-details
                                label="単位"
                                item-text="text"                                
                                outlined />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                            <NumInput 
                                v-model="editItems.measureInterval" 
                                outlined
                                hide-details
                                label="測定周期"
                                type="text" 
                                align="align-left"
                                suffix="分"
                                dense />
                        </v-col>
                    </v-row>
                    <h2 class="mt-4 mb-2">チャート表示</h2>
                    <v-row>
                        <v-col>
                            <NumInput 
                                v-model="editItems.min" 
                                outlined
                                hide-details
                                label="最小値"
                                type="text" 
                                align="align-left"
                                dense />
                        </v-col>
                        <v-col>
                            <NumInput 
                                v-model="editItems.max" 
                                outlined
                                hide-details
                                label="最大値"
                                type="text" 
                                align="align-left"
                                dense />
                        </v-col>
                        <v-col>
                            <NumInput 
                                v-model="editItems.step" 
                                outlined
                                hide-details
                                label="間隔"
                                type="text" 
                                align="align-left"
                                dense />
                        </v-col>
                    </v-row>
                    <h2 class="mt-4 mb-2">警報設定</h2>
                    <v-row dense>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text class="pa-0">
                                    <v-container fluid class="pt-0">
                                        <v-row dense>
                                            <v-col class="pt-0">
                                                <v-checkbox 
                                                    v-model="editItems.alarms.measure.min.enabled"
                                                    hide-details
                                                    label="下限警報を有効にする" />
                                            </v-col>
                                        </v-row>
                                        <v-row >
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.measure.min.value" 
                                                                outlined
                                                                label="下限値"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="℃"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>以下が</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.measure.min.duration" 
                                                                outlined
                                                                label="継続時間"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="分"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>間、継続時に警報</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col class="pt-0">
                                                <v-checkbox 
                                                    v-model="editItems.alarms.measure.max.enabled" 
                                                    hide-details
                                                    label="上限警報を有効にする" />
                                            </v-col>
                                        </v-row>
                                        <v-row >
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.measure.max.value" 
                                                                outlined
                                                                label="上限値"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="℃"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>以上が</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.measure.max.duration" 
                                                                outlined
                                                                label="継続時間"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="分"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>間、継続時に警報</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            上下限共に、
                                                        </td>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.measure.nextAlarmInterval" 
                                                                outlined
                                                                label="再警報間隔"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="分"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>後に再警報</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text class="pa-0">
                                    <v-container fluid class="pt-0">
                                        <v-row dense>
                                            <v-col class="pt-0">
                                                <v-checkbox 
                                                    v-model="editItems.alarms.abnormal.enabled" 
                                                    hide-details
                                                    label="センサー異常警報を有効にする" />
                                            </v-col>
                                        </v-row>
                                        <v-row >
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.abnormal.duration" 
                                                                outlined
                                                                label="監視時間"
                                                                type="text" 
                                                                align="align-left"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>分間に</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.abnormal.value" 
                                                                outlined
                                                                label="発生回数"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="回"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>以上発生時に警報</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <v-row >
                                            <v-col>
                                                <table>
                                                    <tr>
                                                        <td style="width:120px">
                                                            <NumInput 
                                                                v-model="editItems.alarms.abnormal.nextAlarmInterval" 
                                                                outlined
                                                                label="再警報間隔"
                                                                type="text" 
                                                                align="align-left"
                                                                suffix="分"
                                                                hide-details
                                                                dense />
                                                        </td>
                                                        <td>後に再警報</td>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import Confirm from '@/components/tools/ConfirmDialog';

    export default {
        components: {
            Title,
            TitleButton,
            NumInput,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                sensorTypes: [
                    {type: 1, text: "1wire温度センサー"}
                ],
                targetSensor: null,
                editItems: {
                    disabled: false,
                    sensorKey: "",
                    type: 1,
                    type1WireData: {
                        id: ""
                    },
                    name: null,
                    measureInterval: 0,
                    unit: null,
                    min: 0,
                    max: 0,
                    step: 1,
                    alarms: {
                        measure: {
                            min: {
                                enabled: false,
                                value: 0,
                                duration: 0
                            },
                            max: {
                                enabled: false,
                                value: 0,
                                duration: 0
                            },
                            nextAlarmInterval: 0
                        },
                        abnormal: {
                            enabled: false,
                            value: 0,
                            duration: 0,
                            nextAlarmInterval: 0
                        }
                    }
                }
            }
        },
        methods: {
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "登録",
                    message: "この内容で登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.updateSensor()
                        return true
                    },
                })
            },
            /**
             * センサー更新処理
             */
            updateSensor: function () {

                console.log(this.editItems)

                var sensor = this.targetSensor

                if (sensor == null) {
                    sensor = {
                        sensorKey: null,
                        type: null,
                        typeData: null,
                        name: null,
                        measureInterval: 0,
                        unit: null,
                        min: 0,
                        max: 0,
                        step: 0,
                        alarm: null
                    }
                }

                sensor.sensorKey = this.editItems.sensorKey
                sensor.type = this.editItems.type
                sensor.enabled = !this.editItems.disabled
                sensor.name = this.editItems.name
                sensor.measureInterval = this.editItems.measureInterval * 60 * 1000
                sensor.unit = this.editItems.unit
                sensor.min = this.editItems.min * 1
                sensor.max = this.editItems.max * 1
                sensor.step = this.editItems.step * 1
                sensor.alarms = {
                    measure: {
                        min: {
                            enabled: this.editItems.alarms.measure.min.enabled,
                            value: this.editItems.alarms.measure.min.value * 1,
                            durationTime: this.editItems.alarms.measure.min.duration * 1,
                        },
                        max: {
                            enabled: this.editItems.alarms.measure.max.enabled,
                            value: this.editItems.alarms.measure.max.value * 1,
                            durationTime: this.editItems.alarms.measure.max.duration * 1,
                        },
                        nextAlarmInterval: this.editItems.alarms.measure.nextAlarmInterval * 1
                    },
                    abnormal: {
                        enabled: this.editItems.alarms.abnormal.enabled,
                        num: this.editItems.alarms.abnormal.value * 1,
                        watchRange: this.editItems.alarms.abnormal.duration * 1,
                        nextAlarmInterval: this.editItems.alarms.abnormal.nextAlarmInterval * 1
                    }
                }

                switch (this.editItems.type) {
                    case 1:
                        sensor.typeData = {
                            id: this.editItems.type1WireData.id
                        }
                        break;
                }
                this.$emit(
                    "onUpdatedSensor", 
                    {
                        sensor: this.targetSensor,
                        isNewSensor: this.targetSensor == null ? true : false, 
                    }
                )
                this.isView = false
            },
            /**
             * このダイアログを表示する
             */
            show: function (targetSensor) {

                console.log(targetSensor)

                this.targetSensor = targetSensor

                if (targetSensor != null) {
                    this.editItems = {
                        sensorKey: targetSensor.sensorKey,
                        type: targetSensor.type,
                        type1WireData: {
                            id: targetSensor.type == 1 ? targetSensor.typeData.id : null
                        },
                        disabled: !targetSensor.enabled,
                        name: targetSensor.name,
                        measureInterval: targetSensor.measureInterval / 1000 / 60,
                        unit: targetSensor.unit,
                        min: targetSensor.min,
                        max: targetSensor.max,
                        step: targetSensor.step,
                        alarms: {
                            measure: {
                                min: {
                                    enabled: targetSensor.alarms.measure.min.enabled,
                                    value: targetSensor.alarms.measure.min.value,
                                    duration: targetSensor.alarms.measure.min.durationTime
                                },
                                max: {
                                    enabled: targetSensor.alarms.measure.max.enabled,
                                    value: targetSensor.alarms.measure.max.value,
                                    duration: targetSensor.alarms.measure.max.durationTime
                                },
                                nextAlarmInterval: targetSensor.alarms.measure.nextAlarmInterval
                            },
                            abnormal: {
                                enabled: targetSensor.alarms.abnormal.enabled,
                                value: targetSensor.alarms.abnormal.num,
                                duration: targetSensor.alarms.abnormal.watchRange,
                                nextAlarmInterval: targetSensor.alarms.abnormal.nextAlarmInterval
                            }
                        }
                    }
                } else {
                    this.editItems = {
                        sensorKey: "",
                        type: 1,
                        type1WireData: {
                            id: ""
                        },
                        disabled: false,
                        name: null,
                        measureInterval: 0,
                        unit: null,
                        min: 0,
                        max: 0,
                        step: 1,
                        alarms: {
                            measure: {
                                min: {
                                    enabled: false,
                                    value: 0,
                                    duration: 0
                                },
                                max: {
                                    enabled: false,
                                    value: 0,
                                    duration: 0
                                },
                                nextAlarmInterval: 0
                            },
                            abnormal: {
                                enabled: false,
                                value: 0,
                                duration: 0,
                                nextAlarmInterval: 0
                            }
                        }
                    }
                }

                this.isView = true
            }
        }
    }
</script>
